<div class="loading-widget">
    <div class="loading-widget-text">
        <div class="custom-title" mat-dialog-title>SUCCESS!</div>
        <div>Bid this photo welcome to PCL!</div>
    </div>
    <div class="divider-line"></div>
    <div class="loading-widget-image-container">
        <img class="loading-widget-image" src="/assets/images/bidwell-loading-thumbsup.png"/>
    </div>
</div>